import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["menu"]
  static values = { focusOnOpen: Boolean }

  connect() {
    this.closeOnClickOutside = this.closeOnClickOutside.bind(this)
    document.addEventListener("click", this.closeOnClickOutside)
  }

  disconnect() {
    document.removeEventListener("click", this.closeOnClickOutside)
  }

  toggle(event) {
    event.stopPropagation()
    this.menuTarget.classList.toggle("hidden")
    const isOpen = !this.menuTarget.classList.contains("hidden")
    event.currentTarget.setAttribute("aria-expanded", String(isOpen))
    if (isOpen && this.focusOnOpenValue) {
      Array.from(this.menuTarget.querySelectorAll("a, button"))
        .find(item => item.getClientRects().length)?.focus()
    }
  }

  close() {
    if (this.menuTarget.classList.contains("hidden")) return
    this.menuTarget.classList.add("hidden")
    const button = this.element.querySelector("[aria-expanded]")
    if (button) button.setAttribute("aria-expanded", "false")
  }

  navigate(event) {
    const items = Array.from(this.menuTarget.querySelectorAll("a, button"))

    if (event.key === "Escape") {
      this.close()
      const button = this.element.querySelector("[aria-expanded]")
      if (button) button.focus()
    } else if (event.key === "ArrowDown") {
      event.preventDefault()
      const index = items.indexOf(document.activeElement)
      const next = index < items.length - 1 ? index + 1 : 0
      items[next]?.focus()
    } else if (event.key === "ArrowUp") {
      event.preventDefault()
      const index = items.indexOf(document.activeElement)
      const prev = index > 0 ? index - 1 : items.length - 1
      items[prev]?.focus()
    }
  }

  closeOnClickOutside(event) {
    if (!this.element.contains(event.target)) {
      this.close()
    }
  }
}
